import React, { useState } from "react";
import Logo from "../assets/favicon.jpeg";
import { ArrowLeft, Mail } from "lucide-react";
import { getApiBase } from "../utils/apiBase";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const API_BASE = getApiBase();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null); setMessage(null);
    if (!email.trim()) { setError("Email is required."); return; }
    if (!emailRegex.test(email)) { setError("Please enter a valid email address."); return; }
    try {
      setLoading(true);
      await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      setMessage("If this email exists, a password reset link has been sent.");
      setEmail("");
    } catch { setError("Network error. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8f7f5", padding: 16, fontFamily: "'DM Sans', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap');`}</style>

      <div style={{ width: 400, maxWidth: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <img src={Logo} alt="JAC Logo" style={{ width: 64, height: 64, borderRadius: "16px", objectFit: "cover", marginBottom: "14px" }} />
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: 600, color: "#111827" }}>Scan Pay Go</h1>
          <p style={{ margin: "4px 0 0", fontSize: "14px", color: "#9ca3af" }}>Admin dashboard</p>
        </div>

        <div style={{ background: "#fff", borderRadius: "20px", padding: "32px", border: "1px solid #f3f4f6", boxShadow: "0 4px 24px rgba(0,0,0,0.06)" }}>

          {/* Icon */}
          <div style={{ width: "48px", height: "48px", borderRadius: "14px", background: "#fff5f2", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "20px" }}>
            <Mail size={22} color="#F1561D" />
          </div>

          <h2 style={{ margin: "0 0 8px", fontSize: "18px", fontWeight: 600, color: "#111827" }}>Reset your password</h2>
          <p style={{ margin: "0 0 24px", fontSize: "14px", color: "#9ca3af", lineHeight: 1.5 }}>Enter your registered email and we'll send you a reset link.</p>

          {error && (
            <div style={{ marginBottom: "16px", padding: "12px 14px", borderRadius: "10px", background: "#fff5f5", border: "1px solid #fecaca", fontSize: "13px", color: "#b91c1c" }}>
              {error}
            </div>
          )}

          {message && (
            <div style={{ marginBottom: "16px", padding: "12px 14px", borderRadius: "10px", background: "#f0fdf4", border: "1px solid #bbf7d0", fontSize: "13px", color: "#166534" }}>
              {message}
            </div>
          )}

          {!message && (
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div>
                <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#374151", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px" }}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  required
                  style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "10px 14px", fontSize: "14px", color: "#111827", outline: "none", boxSizing: "border-box", background: "#fafafa" }}
                  onFocus={e => (e.target.style.borderColor = "#F1561D")}
                  onBlur={e => (e.target.style.borderColor = "#e5e7eb")}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                style={{ height: "44px", borderRadius: "10px", border: "none", background: loading ? "#fdba99" : "#F1561D", color: "#fff", fontSize: "15px", fontWeight: 600, cursor: loading ? "not-allowed" : "pointer" }}
              >
                {loading ? "Sending…" : "Send Reset Link"}
              </button>
            </form>
          )}

          <div style={{ marginTop: "24px", textAlign: "center" }}>
            <a href="/" style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px", color: "#6b7280", textDecoration: "none", fontWeight: 500 }}>
              <ArrowLeft size={14} /> Back to sign in
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
